module.exports = __webpack_public_path__ + "img/instagram.486f465e.svg";